import { createFileRoute } from '@tanstack/react-router';
import { createGroupBroadcastDetailRoute } from '@/lib/route-factories/group-broadcast-route';

export const Route = createFileRoute(
  '/_authed/circles/$id/admin/broadcasts/$broadcastId/',
)(
  createGroupBroadcastDetailRoute({
    kind: 'circle',
    fromId: '/_authed/circles/$id/admin/broadcasts/$broadcastId/',
  }),
);
